import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

export const reEvaluationRequestCove = async (data: object) => {
  return axios.put(endpoints.coveReEvaluationRequest, data)
}

export const useReEvaluationRequestCove = () => {
  const queryClient = useQueryClient()
  return useMutation(reEvaluationRequestCove, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.CoveLisiting, ApiKey.list])
    },
  })
}
